<template>
	<div class="main">
		<div class="rank" :class="{'isFixed':searchBarFixed}">
			<div class="rank-click fn-right" :class="{'reverse': isReverse}" @click="isReverse = !isReverse" id="rank">
				{{text}}
			</div>
			<div class="logo-txt">
				<ul class="comment-type">
					<li :class="{'comment-type-active':commentType==0}" @click="selectComment(0)">直播</li>
					<li :class="{'comment-type-active':commentType==1}" @click="selectComment(1)">评论</li>
				</ul>
			</div>
		</div>
		<div class="live-line">
			<transition-group name="list">
			    <Comment v-if="commentType==0" 
			    	v-for="item in comments" 
			    	:key="item.id" 
			    	:id="item.id" 
			    	:avatar="item.avatar" 
			    	:username="item.username" 
			    	:grade="item.grade" 
			    	:createTime="item.createTime" 
			    	:context="item.context" 
			    	:address="item.address" 
			    	:images="item.images" 
			    	:video="item.video"></Comment>
				<GuestComment v-if="commentType==1"  v-for="item in comments" 
					:key="item.id" 
					:id="item.id" 
					:avatar="item.avatar" 
					:username="item.username" 
					:grade="item.grade" 
					:createTime="item.createTime" 
					:context="item.context" 
					:address="item.address">
				</GuestComment>
			</transition-group>
		</div>
		<div class="live-bottom"><span>已展示全部内容</span></div>
	</div>
</template>

<script>
	import Comment from "./comment"
	import GuestComment from "./guestComment"
	export default {
		name: "Comments",
		components: {
			Comment,
			GuestComment
		},
		props: {
			data: Array
		},
		data() {
			return {
				isReverse: true,
				commentType: 0,
				searchBarFixed: false,
			}
		},
		computed: {
			comments() {
				return this.data.sort((a, b) => {
					return this.isReverse ? (a.createTime <= b.createTime ? 1 : -1) : (a.createTime >= b.createTime ? 1 : -1);
				})
			},
			text() {
				return this.isReverse ? "倒序浏览" : "正序浏览"
			}
		},
		methods: {			
			selectComment(type){
				this.commentType=type;
				this.$emit('selectComment', type);				
				let u = navigator.userAgent;
  				let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				let isZGapp = u.indexOf('ZgApp') >= 0;
  				console.log(u);
  				if (isiOS && isZGapp) {
  					window.webkit.messageHandlers.changeCommentType.postMessage({'type':type});
  				} else if(isAndroid && isZGapp) {
    				window.native_zg_live.changeCommentType(type);
  				}
			},
			handleScroll() {
				let max_width = window.innerWidth.toString()>1100?1100:window.innerWidth.toString();
				let height= (max_width * (9 / 16)).toString();				
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				var offsetTop = document.querySelector('.rank').offsetTop;
				if((parseInt(scrollTop)+parseInt(height))>parseInt(offsetTop)) {
					this.searchBarFixed = true;
					document.querySelector('.rank').style.width=(max_width-(max_width>=1100?32:22))+"px";
					document.querySelector('.rank').style.top=height+"px";
				} else {
					this.searchBarFixed = false;
				}
			}

		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		}
	}
</script>

<style scoped>
	/*.list-enter-active,
	.list-leave-active {
		transition: all 2s;
	}
	
	.list-enter,
	.list-leave-to {
		opacity: 0;
		transform: translateY(50px);
	}*/
	/* .list-move {
    transition: transform 0.5s;
} */
	
	.comment-type {
		display: inline;
	}
	
	.comment-type li {
		font-size: 0.5rem;
		float: left;
		padding: 0.3rem 0.3rem;		
	}
	.comment-type-active {
		color: red;
		border-bottom: 0.04rem red solid !important;
	}
	
	.isFixed {
		position: fixed;
		/*top: 5.5rem;
		width: 94%;*/
		z-index: 1000;
	}
</style>